import React, { useEffect, useState } from "react";
import "./Gallery.css";
import { CgEditHighlight } from "react-icons/cg";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://api.mitadtu.in";

const Gallery = () => {
  const [open, setOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [slides, setSlides] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchGallery();
    fetchYears();
  }, []);

  const fetchGallery = async (year = "") => {
    setLoading(true);
    setError("");
    try {
      const url = `${API_BASE}/api/admin/gallery/public?t=${Date.now()}${year ? "&year=" + year : ""}`;
      const res = await fetch(url, { cache: 'no-store' });
      const data = await res.json();
      if (data.success) {
        const sorted = (data.data || []).sort((a, b) => b.id - a.id);
        setGallery(sorted);
      } else {
        setError("Failed to load gallery");
      }
    } catch (err) {
      console.error("Gallery fetch error:", err);
      setError("Server Error");
    } finally {
      setLoading(false);
    }
  };

  const fetchYears = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/admin/gallery/public/years`);
      const data = await res.json();
      if (data.success) setYears(data.data || []);
    } catch (err) {
      console.error("Years fetch error:", err);
    }
  };

  const handleYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);
    fetchGallery(year);
  };

  const openLightbox = (images, idx) => {
    setSlides(images.map((i) => ({ src: `${API_BASE}${i}` })));
    setLightboxIndex(idx);
    setOpen(true);
  };

  return (
    <div>
      <div className="gallery-header">
        <h1 className="title">Gallery</h1>
        {years.length > 0 && (
          <div className="selectedYear">
            <label className="year-title">Select Year: </label>
            <select className="selectyear" value={selectedYear} onChange={handleYearChange}>
              <option value="">All</option>
              {years.map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </div>
        )}
      </div>

      {error && <div className="alert error">{error}</div>}

      {loading ? (
        <p>Loading gallery...</p>
      ) : gallery.length === 0 ? (
        <div className="no-gallery">
          <p>No approved gallery items found.</p>
          <small>Note: Only approved galleries are displayed.</small>
        </div>
      ) : (
        <div className="gallery-grid">
          {gallery.map((item) => {
            const images = item.gallery_image || [];
            const isExpanded = expandedId === item.id;
            const visibleImages = isExpanded ? images : images.slice(0, 8);

            return (
              <div key={item.id} className="gallery-card">
                <div className="happening-top">
                  <CgEditHighlight className="happening-icon" />
                  <h3 className="happening-heading">{item.title}</h3>
                </div>

                <div className="gallery-meta">
                  {item.from_date && item.to_date && (
                    <p>
                      <strong>Period:</strong>{" "}
                      {new Date(item.from_date).toLocaleDateString()} –{" "}
                      {new Date(item.to_date).toLocaleDateString()}
                    </p>
                  )}
                  {item.meta_tag && (
                    <p><strong>Description:</strong> {item.meta_tag}</p>
                  )}
                </div>

                {images.length > 0 && (
                  <div className="gallery-images">
                    {visibleImages.map((img, idx) => (
                      <img
                        key={idx}
                        src={`${API_BASE}${img}`}
                        alt={`gallery-${idx}`}
                        className="gallery-img"
                        loading="lazy"
                        onClick={() => openLightbox(images, idx)}
                      />
                    ))}

                    {images.length > 8 && (
                      <div
                        className="more-images-overlay"
                        onClick={() => setExpandedId(isExpanded ? null : item.id)}
                      >
                        {isExpanded ? "Show Less" : `+${images.length - 8} more`}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* Single Lightbox outside the loop */}
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        index={lightboxIndex}
        plugins={[Slideshow]}
      />
    </div>
  );
};

export default Gallery;
